import React, { useEffect, useState } from 'react';
import NumberInput from '../../../components/library/inputs/number/NumberInput';

interface PaymentFeeProps {
  content: string;
  editMode?: boolean;
  onChange: (content: string) => void;
}

export const PaymentFee: React.FC<PaymentFeeProps> = ({ content, editMode = false, onChange }) => {
  const { fixed, percent } = JSON.parse(content);
  const [percentValue, setPercentValue] = useState(percent);
  const [fixedValue, setFixedValue] = useState(fixed);

  useEffect(() => {
    const { fixed, percent } = JSON.parse(content);
    setPercentValue(percent);
    setFixedValue(fixed);
  }, [editMode]);

  return (
    <div className="setting-content">
      {!editMode && (
        <div className="d-flex align-items-center">
          <div>{percent}</div>
          <div className="ms-1">%</div>
          <div className="mx-2">+</div>
          <div className="me-1">$</div>
          <div>{fixed}</div>
        </div>
      )}
      {editMode && (
        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center">
            <div style={{ width: 90 }}>
              <NumberInput
                value={percentValue}
                onChange={(e) => {
                  setPercentValue(parseFloat(e.target.value));
                  onChange(JSON.stringify({ percent: parseFloat(e.target.value) || 0, fixed: fixedValue, minimum: 0 }));
                }}
              />
            </div>
            <div className="ms-1">%</div>
            <div className="mx-2">+</div>
            <div className="me-1">$</div>
            <div style={{ width: 90 }}>
              <NumberInput
                value={fixedValue}
                onChange={(e) => {
                  setFixedValue(parseFloat(e.target.value));
                  onChange(
                    JSON.stringify({ percent: percentValue, fixed: parseFloat(e.target.value) || 0, minimum: 0 }),
                  );
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentFee;
